import { useState } from 'react';
import { decideChunkErrorRecovery } from './core';

/**
 * For error-boundary fallbacks: when the caught error is a missing-chunk
 * failure, reload once (guarded — see core.ts) and return true so the
 * fallback renders a spinner instead of an error box while the page is
 * being replaced. Returns false for every other error.
 */
export function useChunkErrorAutoReload(error: unknown): boolean {
    // Lazy initializer: the decision lands before first paint, once per
    // mount — idempotent under StrictMode because recovery latches in
    // module state.
    const [reloading] = useState(() => decideChunkErrorRecovery(error));
    return reloading;
}
